import React, { useState, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const YearFilter = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    const yearParam = searchParams.get("year");
    if (yearParam) {
      setSelectedDate(new Date(parseInt(yearParam), 0, 1));
    }
  }, [searchParams]);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);

    const params = new URLSearchParams(searchParams);
    if (date) {
      params.set("year", date.getFullYear().toString());
    } else {
      params.delete("year");
    }
    router.push(`?${params.toString()}`, { scroll: false });
  };

  const handleReset = () => {
    setSelectedDate(null);
    const params = new URLSearchParams(searchParams);
    params.delete("year");
    router.push(`?${params.toString()}`, { scroll: false });
  };

  return (
    <div className="flex items-center relative">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        showYearPicker
        dateFormat="yyyy"
        placeholderText="----"
        customInput={
          <input className="px-4 rounded-full py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:border-transparent max-w-24" />
        }
        calendarClassName="w-40"
      />

      <Button
        onClick={handleReset}
        variant={"ghost"}
        className="p-1 m-1 h-fit absolute right-1"
      >
        <X />
      </Button>
    </div>
  );
};

export default YearFilter;
